import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { toggleDeviceDetailsWindow } from '../mutators/toggleDeviceDetailsWindow';
import { selectMobileDevice } from '../mutators/selectMobileDevice';
import { IconButton, ButtonType } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
var styles = require('./MobileDeviceFull.scss');
var EditButton = /** @class */ (function (_super) {
    tslib_1.__extends(EditButton, _super);
    function EditButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClicked = function () {
            if (_this.props.index !== undefined && _this.props.index >= 0) {
                selectMobileDevice(_this.props.index);
                toggleDeviceDetailsWindow();
            }
        };
        return _this;
    }
    EditButton.prototype.render = function () {
        return (React.createElement(IconButton, { buttonType: ButtonType.command, onClick: this.onClicked, iconProps: { iconName: "Edit" /* Edit */ }, className: styles.command, title: strings.options_mobile_full_editButton }));
    };
    EditButton = tslib_1.__decorate([
        observer
    ], EditButton);
    return EditButton;
}(React.Component));
export default EditButton;
//# sourceMappingURL=EditButton.js.map